module.exports = __webpack_public_path__ + "images/panorama-da8a5f8f09bf396fb92d113dbe2a9330.jpg";